var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view border-box",attrs:{"scroll-x":"true"}},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"item border-box pointer flex flex-center-sp flex-center-cz",class:{'active': item.id == _vm.value},on:{"click":function($event){return _vm.selectClick(item)}}},[_vm._v(_vm._s(item.name))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f2a0d76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/selectTag/SelectTag.vue
// module id = null
// module chunks = 